/**
 * HELP-MODAL
 * Tutorial displayed on the right side of the screen
 */
import Card from "@/components/card"
import { useEffect, useState } from "react"
import { withTranslation, WithTranslation } from "react-i18next"
import Button from "./button"
import Scroller from "./scroller"
import Space from "./space"
import { SlideIn } from "@/utils/animations.utils"

interface OwnProps extends WithTranslation {
  children?: any
  isLarge?: boolean
  isFullHeight?: boolean //Takes the whole height of the screen (the content scrolls inside)
  onClose?: Function
  title?: React.ReactNode
  isLeft?: boolean
  option?: any
  decoration?: React.ReactNode //Placed at the bottom left of the window, over the footer
}

//Height taken by the rest of the window (top and bottom margins of 12 px, title, close button) : the scrollable area gets the remaining height
const FULL_HEIGHT_CHROME = 174

function HelpModal(props: OwnProps) {
  const { t } = props

  //Height of the screen : the scrollable area follows it when the window is full height
  const [viewportHeight, setViewportHeight] = useState<number>(window.innerHeight)
  useEffect(() => {
    if (!props.isFullHeight) return
    const onResize = () => setViewportHeight(window.innerHeight)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [props.isFullHeight])

  return (
    <div
      className={
        "modal-help-container flex " + (props.isLarge ? "modal-help-large " : "") + (props.isFullHeight ? "modal-help-full" : "")
      }
      onClick={(e) => {
        //A click on the dark background (outside the window) closes it
        if (e.target === e.currentTarget && props.onClose) props.onClose()
      }}>
      <div className={`modal-help modal-help-${props.isLeft ? "left" : "right"}`}>
        <SlideIn isLeft={props.isLeft}>
          <Card title={props.title}>
            <div className={`modal-help-content modal-help-content-${props.isLeft ? "left" : "right"}`}>
              <Scroller maxHeight={props.isFullHeight ? viewportHeight - FULL_HEIGHT_CHROME : 400}>
                <div style={props.isLeft ? { paddingLeft: "20px" } : { paddingRight: "20px" }}>{props.children}</div>
              </Scroller>
            </div>

            {props.onClose && (
              <div className="flex" style={{ marginTop: props.isFullHeight ? "20px" : "32px" }}>
                {props.option && <div className={props.decoration ? "modal-help-option-decorated" : ""}>{props.option}</div>}
                <Space />
                <Button onClick={props.onClose} className="primary">
                  {t("utils_close")}
                </Button>
              </div>
            )}

            {props.decoration && <div className="modal-help-decoration">{props.decoration}</div>}
          </Card>
        </SlideIn>
      </div>
    </div>
  )
}

export default withTranslation()(HelpModal)
